import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=e64211fc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e64211fc')) {
      api.createRecord('e64211fc', component.options)
    } else {
      api.reload('e64211fc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=e64211fc&", function () {
      api.rerender('e64211fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FKAOR5F2LF4j/JS/comp/FavElement.vue"
export default component.exports